import type { SVGProps } from "react";

export function HomeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect width="38" height="38" rx="4" fill="#F8DFB0" />
      <path
        d="M20.4079 8.49783C19.5853 7.83796 18.4147 7.83796 17.5921 8.49783L9.84212 14.7146C9.30976 15.1416 9 15.7872 9 16.4697V27.7499C9 28.9926 10.0074 29.9999 11.25 29.9999H13.75C14.9926 29.9999 16 28.9926 16 27.7499V22.25C16 21.5596 16.5596 21 17.25 21H20.75C21.4404 21 22 21.5596 22 22.25V27.7499C22 28.9926 23.0074 29.9999 24.25 29.9999H26.75C27.9926 29.9999 29 28.9926 29 27.7499V16.4697C29 15.7872 28.6902 15.1416 28.1579 14.7146L20.4079 8.49783Z"
        fill="#71441B"
      />
    </svg>
  );
}
